import { render } from "./Parcelas.vue?vue&type=template&id=2aabb9c0&scoped=true"
import script from "./Parcelas.vue?vue&type=script&lang=js"
export * from "./Parcelas.vue?vue&type=script&lang=js"

import "./Parcelas.vue?vue&type=style&index=0&id=2aabb9c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aabb9c0"]])

export default __exports__